import React from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import Paper from "@material-ui/core/Paper";
import FileUploader from "react-firebase-file-uploader";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import UploadIcon from "@material-ui/icons/CloudUpload";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ChromePicker } from "react-color";
import { defaultColor } from "../../constants/DefaultColor";
import SponsorBlock from "./SponsorBlock";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { validateFileSize } from "../../util/uploadErrors";

const DesignSettings = (props) => (
  <div style={{ width: "100%" }}>
    <div style={{ width: 650, maxWidth: "97%", margin: "auto" }}>
      <Typography
        variant="h6"
        style={{ marginTop: props.allowedToUpload ? 50 : 30 }}
      >
        {languages.tournament.design}
      </Typography>
      <Typography variant="caption">
        {languages.tournament.designDescription}
      </Typography>
      {!props.tournament.isPSD && (
        <div style={{ marginTop: 30 }}>
          <Typography style={{ fontWeight: 500 }}>
            {languages.tournament.color}
          </Typography>
          <Typography variant="caption">
            {languages.tournament.colorDescription}
          </Typography>
          <div style={{ paddingTop: 5 }}>
            {props.colorLockMessage && (
              <div style={{ color: "red", marginBottom: 3 }}>
                {props.colorLockMessage}
              </div>
            )}
            <ChromePicker
              color={props.tournament.color || defaultColor}
              onChangeComplete={
                props.tournament.isPSD
                  ? props.handleColorLock
                  : props.allowedToUpload
                  ? props.handleChangeComplete
                  : props.toggleUpgradeDialog
              }
              disableAlpha={true}
            />
          </div>
        </div>
      )}
      <div style={{ marginTop: 50 }}>
        <Typography style={{ fontWeight: 500 }}>
          {languages.tournament.logo}
        </Typography>
        <Typography variant="caption">
          {languages.tournament.logoDescription}
        </Typography>
        {props.errorMessageLogo && (
          <div>
            <Typography style={{ color: "red" }}>
              {props.errorMessageLogo}
            </Typography>
          </div>
        )}
        {props.tournament.ia && props.warningSVG.type === "logos" && (
          <div>
            <Typography variant="caption" style={{ color: "red" }}>
              {languages.present.warningSVG}
            </Typography>
          </div>
        )}
        <Grid
          container
          spacing={1}
          alignItems="flex-start"
          style={{ marginBottom: 15, marginTop: 5 }}
        >
          <Grid item xs={7} sm={7} md={7} lg={7}>
            <Paper style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  height: 180,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {props.isUploading && props.uploadingType === "logos" ? (
                  <CircularProgress size={28} />
                ) : props.tournament.logoURL ? (
                  <img
                    style={{
                      maxWidth: "100%",
                      maxHeight: 180,
                      margin: "auto",
                      verticalAlign: "middle",
                    }}
                    src={props.tournament.logoURL}
                    alt=""
                  />
                ) : (
                  <Typography
                    style={{
                      color: "gray",
                      display: "inline-block",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {languages.tournament.logo}
                  </Typography>
                )}
              </div>
            </Paper>
          </Grid>
          <Grid item xs={5} sm={5} md={5} lg={5}>
            <FileUploader
              id="upload-logo"
              style={{ display: "none" }}
              accept="image/*"
              name="logoUpload"
              randomizeFilename
              storageRef={props.logoStorageRef}
              beforeUploadStart={(file) => {
                validateFileSize(file, 1);
              }}
              onUploadStart={() => props.handleUploadStart("logos")}
              onUploadError={(error) => {
                props.handleUploadError(error, "logos");
              }}
              onUploadSuccess={(fileName) => {
                props.handleUploadSuccess(fileName, "logos");
              }}
              onProgress={props.handleProgress}
            />
            <label htmlFor={props.allowedToUpload ? "upload-logo" : ""}>
              <Button
                size="small"
                fullWidth
                variant="outlined"
                component="span"
                color="primary"
                onClick={
                  !props.allowedToUpload ? props.toggleUpgradeDialog : () => {}
                }
              >
                {languages.tournament.upload}
                <UploadIcon style={{ marginLeft: 5 }} />
              </Button>
            </label>
            {props.tournament.logoURL && (
              <Button
                style={{ marginTop: 5 }}
                size="small"
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={() => props.toggleDeleteDialog("logos")}
              >
                {languages.general.delete}
                <DeleteIcon />
              </Button>
            )}
          </Grid>
        </Grid>
      </div>

      <div style={{ marginTop: 50 }}>
        <Typography style={{ fontWeight: 500 }}>
          {languages.tournament.background}
        </Typography>
        <Typography variant="caption">
          {languages.tournament.backgroundDescription}
        </Typography>
        {props.errorMessageBG && (
          <div>
            <Typography style={{ color: "red" }}>
              {props.errorMessageBG}
            </Typography>
          </div>
        )}
        {props.tournament.ia && props.warningSVG.type === "backgrounds" && (
          <div>
            <Typography variant="caption" style={{ color: "red" }}>
              {languages.present.warningSVG}
            </Typography>
          </div>
        )}
        <Grid
          container
          spacing={1}
          alignItems="flex-start"
          style={{ marginBottom: 15, marginTop: 5 }}
        >
          <Grid item xs={7} sm={7} md={7} lg={7}>
            <Paper style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  height: 180,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {props.isUploading && props.uploadingType === "backgrounds" ? (
                  <CircularProgress size={28} />
                ) : props.tournament.bgURL ? (
                  <img
                    style={{
                      maxWidth: "100%",
                      maxHeight: 180,
                      margin: "auto",
                      verticalAlign: "middle",
                    }}
                    src={props.tournament.bgURL}
                    alt=""
                  />
                ) : (
                  <Typography
                    style={{
                      color: "gray",
                      display: "inline-block",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {languages.tournament.background}
                  </Typography>
                )}
              </div>
            </Paper>
          </Grid>
          <Grid item xs={5} sm={5} md={5} lg={5}>
            <FileUploader
              id="upload-background"
              style={{ display: "none" }}
              accept="image/*"
              name="backgroundUpload"
              randomizeFilename
              storageRef={props.backgroundStorageRef}
              beforeUploadStart={(file) => {
                validateFileSize(file, 3);
              }}
              onUploadStart={() => props.handleUploadStart("backgrounds")}
              onUploadError={(error) => {
                props.handleUploadError(error, "backgrounds");
              }}
              onUploadSuccess={(fileName) => {
                props.handleUploadSuccess(fileName, "backgrounds");
              }}
              onProgress={props.handleProgress}
            />
            <label
              htmlFor={
                props.allowedToUpload && props.tournament.nvdCode === undefined
                  ? "upload-background"
                  : ""
              }
            >
              <Button
                size="small"
                fullWidth
                variant="outlined"
                component="span"
                color="primary"
                onClick={
                  !props.allowedToUpload ? props.toggleUpgradeDialog : () => {}
                }
                disabled={props.tournament.nvdCode !== undefined}
              >
                {languages.tournament.upload}
                <UploadIcon style={{ marginLeft: 5 }} />
              </Button>
            </label>
            {props.tournament.bgURL && (
              <Button
                style={{ marginTop: 5 }}
                size="small"
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={() => props.toggleDeleteDialog("backgrounds")}
                disabled={props.tournament.nvdCode !== undefined}
              >
                {languages.general.delete}
                <DeleteIcon />
              </Button>
            )}
          </Grid>
        </Grid>
      </div>

      <Typography style={{ fontWeight: 500, marginTop: 50 }}>
        {languages.tournament.sponsors}
      </Typography>
      <Typography variant="caption">
        {languages.tournament.sponsorsDescription}
      </Typography>
      {props.tournament.ia && props.warningSVG.type === "sponsors" && (
        <div>
          <Typography variant="caption" style={{ color: "red" }}>
            {languages.present.warningSVG}
          </Typography>
        </div>
      )}
      <DragDropContext onDragEnd={props.onDragEndBlock}>
        <Droppable droppableId="blockDrop">
          {(provided, snapshot) => {
            return (
              <div ref={provided.innerRef}>
                {/* <Draggable draggableId={"0"} index={0}>
                  {(provided, snapshot) => (
                    <div>
                      <div ref={provided.innerRef} {...provided.draggableProps}>
                        <SponsorBlock
                          dragHandleProps={provided.dragHandleProps}
                          sponsorStorageRef={props.sponsorStorageRef}
                          handleUploadStart={props.handleUploadStart}
                          handleUploadError={props.handleUploadError}
                          handleUploadSuccess={props.handleUploadSuccess}
                          handleProgress={props.handleProgress}
                          allowedToUpload={props.allowedToUpload}
                          tournament={props.tournament}
                          toggleUpgradeDialog={props.toggleUpgradeDialog}
                          toggleDeleteDialog={props.toggleDeleteDialog}
                          openSponsorLinkDialog={props.openSponsorLinkDialog}
                          sponsorGroup={props.sponsorGroup}
                          toggleSponsorLinkDialog={
                            props.toggleSponsorLinkDialog
                          }
                          errorMessageSponsors={props.errorMessageSponsors}
                          sponsorsTemp={props.sponsorsTemp}
                          sponsorLinksTemp={props.sponsorLinksTemp}
                        />
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Draggable> */}
                {props.allSponsors.map((extraSponsor, num) => {
                  return (
                    <Draggable
                      key={num}
                      draggableId={num.toString()}
                      index={num}
                    >
                      {(provided, snapshot) => (
                        <div>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                          >
                            <SponsorBlock
                              dragHandleProps={provided.dragHandleProps}
                              blockNum={
                                extraSponsor[1] === 0
                                  ? undefined
                                  : extraSponsor[1]
                              }
                              sponsorStorageRef={props.sponsorStorageRef}
                              handleUploadStart={props.handleUploadStart}
                              handleUploadError={props.handleUploadError}
                              handleUploadSuccess={props.handleUploadSuccess}
                              handleProgress={props.handleProgress}
                              allowedToUpload={props.allowedToUpload}
                              tournament={props.tournament}
                              toggleUpgradeDialog={props.toggleUpgradeDialog}
                              toggleDeleteDialog={props.toggleDeleteDialog}
                              openSponsorLinkDialog={
                                props.openSponsorLinkDialog
                              }
                              sponsorGroup={props.sponsorGroup}
                              toggleSponsorLinkDialog={
                                props.toggleSponsorLinkDialog
                              }
                              errorMessageSponsors={props.errorMessageSponsors}
                              sponsorsTemp={props.sponsorsTemp}
                              sponsorLinksTemp={props.sponsorLinksTemp}
                              isUploading={props.isUploading}
                              uploadingType={props.uploadingType}
                              uploadingSponsorIndex={
                                props.uploadingSponsorIndex
                              }
                              uploadingSponsorGroup={
                                props.uploadingSponsorGroup
                              }
                            />
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>
      </DragDropContext>
      <SponsorBlock
        dragHandleProps={{}}
        blockNum={props.lastSponsor + 1}
        sponsorStorageRef={props.sponsorStorageRef}
        handleUploadStart={props.handleUploadStart}
        handleUploadError={props.handleUploadError}
        handleUploadSuccess={props.handleUploadSuccess}
        handleProgress={props.handleProgress}
        allowedToUpload={props.allowedToUpload}
        tournament={props.tournament}
        toggleUpgradeDialog={props.toggleUpgradeDialog}
        toggleDeleteDialog={props.toggleDeleteDialog}
        openSponsorLinkDialog={props.openSponsorLinkDialog}
        sponsorGroup={props.sponsorGroup}
        toggleSponsorLinkDialog={props.toggleSponsorLinkDialog}
        errorMessageSponsors={props.errorMessageSponsors}
        new
        isUploading={props.isUploading}
        uploadingType={props.uploadingType}
        uploadingSponsorIndex={props.uploadingSponsorIndex}
        uploadingSponsorGroup={props.uploadingSponsorGroup}
      />
    </div>
  </div>
);

export default DesignSettings;
